var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStyles, makeStyles } from '@hawkins/styles';
import { datePickerStyles } from './datePicker.styles';
export var datePickerInputStyles = function (theme) {
    var baseStyles = datePickerStyles(theme);
    return createStyles(__assign(__assign({}, baseStyles), { 
        /** Class name applied to the DatePickerInput "dropdown" variant */
        dropdown: {
            '&:hover': {
                cursor: 'pointer',
            },
        }, 
        /** Class applied to the end adornment for variant "dropdown" */
        dropdownEndAdornment: {
            '& button svg': {
                fontSize: '1em',
                height: '1em',
                width: 'auto',
            },
        }, 
        /** Class applied to the start adornment for variant "dropdown" */
        dropdownStartAdornment: {
            '&:hover': {
                cursor: 'pointer',
            },
        } }));
};
export var useDatePickerInputStyles = makeStyles(datePickerInputStyles, { name: 'Hawkins-DatePickerInput' });
